import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import logo from "assets/images/comedor.png";
import LogoSL from "assets/images/logo-sl.png";

const PdfHeader = () => {
  return (
    <Grid
      container
      pb={2}
      mb={2}
      mt={0}
      pt={1}
      sx={{
        borderBottom: 2,
        borderColor: "rgba(222, 0, 118)",
      }}
    >
      <Grid item xs={12} display="flex" justifyContent="center">
        {/* Using the comedor logo */}
        <img src={logo} alt="UPrO" width="10%" />
      </Grid>
      {/* <Grid item xs={6} display="flex" flexDirection="column" gap={1} alignItems="end">
        <img src={LogoSL} alt="UPrO" width="30%" />
      </Grid> */}
    </Grid>
  );
};

export default PdfHeader;
